// Global interceptors for feedback context capture.
// Call init() once at app startup. Call getSnapshot() when submitting feedback.

const recentApiCalls = [];
const recentErrors   = [];
const MAX_CALLS  = 10;
const MAX_ERRORS = 5;

let initialised = false;

export function init() {
  if (initialised) return;
  initialised = true;

  // Intercept fetch — record last 10 API calls (path + method + status)
  const origFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const url    = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const method = (args[1]?.method || 'GET').toUpperCase();
    let res;
    try {
      res = await origFetch(...args);
      const path = url.replace(window.location.origin, '').replace(/^https?:\/\/[^/]+/, '');
      recentApiCalls.push({ method, path, status: res.status, ts: Date.now() });
      if (recentApiCalls.length > MAX_CALLS) recentApiCalls.shift();
      return res;
    } catch (err) {
      recentApiCalls.push({ method, path: url, status: 'ERR', ts: Date.now() });
      if (recentApiCalls.length > MAX_CALLS) recentApiCalls.shift();
      throw err;
    }
  };

  // Intercept console.error — record last 5 JS errors
  const origError = console.error.bind(console);
  console.error = (...args) => {
    const msg = args.map(a => (typeof a === 'object' ? JSON.stringify(a) : String(a))).join(' ').slice(0, 300);
    recentErrors.push({ msg, ts: Date.now() });
    if (recentErrors.length > MAX_ERRORS) recentErrors.shift();
    origError(...args);
  };

  // Capture unhandled JS errors
  window.addEventListener('error', e => {
    const msg = `${e.message} (${e.filename}:${e.lineno})`.slice(0, 300);
    recentErrors.push({ msg, ts: Date.now() });
    if (recentErrors.length > MAX_ERRORS) recentErrors.shift();
  });
}

export function getSnapshot() {
  const now = Date.now();
  const since60s = ts => now - ts < 60_000;

  return {
    apiCalls: recentApiCalls
      .filter(c => since60s(c.ts))
      .map(c => `${c.method} ${c.path} → ${c.status}`)
      .join('\n') || 'none',

    consoleErrors: recentErrors
      .filter(e => since60s(e.ts))
      .map(e => e.msg)
      .join('\n') || 'none',

    screenWidth:  window.innerWidth,
    screenHeight: window.innerHeight,

    sessionSeconds: Math.round(
      (now - (window.performance?.timing?.navigationStart || now)) / 1000
    ),
  };
}
